import storageKeys from '../configuration/storageKeys'

export const getLabelsData = () =>
  JSON.parse(sessionStorage.getItem(storageKeys.labels))
